import { useCallback } from 'react';
import { message } from 'antd';

/**
 * Custom hook for displaying notifications
 * Uses Ant Design message API for toast notifications.
 * Callbacks are memoized so consumers can safely put them in useCallback/useEffect deps
 * (unstable references previously caused infinite fetch loops on calculator settings pages).
 */
export const useNotification = () => {
  const showSuccess = useCallback((msg) => {
    message.success(msg);
  }, []);

  const showError = useCallback((msg) => {
    message.error(msg);
  }, []);

  const showWarning = useCallback((msg) => {
    message.warning(msg);
  }, []);

  const showInfo = useCallback((msg) => {
    message.info(msg);
  }, []);

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
};
